import APIService from '@/services/APIService.js';

export default {
  listar(filtros = {}) {
    return APIService.apiCall().get('/gestao-bdgds-erros/listar', {
      params: { ...filtros }
    });
  },

  listarEtapas(filtros = {}) {
    return APIService.apiCall().get('/gestao-bdgds-erros/etapas', {
      params: { ...filtros }
    });
  },

  buscarFiltros(filtros = {}) {
    return APIService.apiCall().get('/gestao-bdgds-erros/filtros', {
      params: { ...filtros }
    });
  },

  buscarNomesValidacoes(filtros = {}) {
    return APIService.apiCall().get('/gestao-bdgds-erros/filtros/nome-validacao', {
      params: { ...filtros }
    });
  },

  buscarTarefaNaLista(tarefaId, filtros = {}) {
    return APIService.apiCall().get(`/gestao-bdgds-erros/tarefas/${tarefaId}/resumo`, {
      params: { ...filtros }
    });
  }
};
